/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class QueryRunnerAPI
 * @hideconstructor
 * @classdesc API class that is used to optimize queries (combines queries into one)
 */
define([], () => {
	class QueryRunnerAPI {

		/**
		 * @function QueryRunnerAPI#setup
		 * @description initializes
		 *
		 * @param {Object} queryService
		 * @param {Object} [options] additional options to pass to query runner
		 */
		setup(){}

		/**
		 * @function QueryRunnerAPI#runQuery
		 * @description Execute query.
		 * @async
		 *
		 * @param {String} sourceIdOrModule: The sourceId with which query is based on
		 * @param {Object} querySpec The query specification.
		 * @param {Object} requestOptions additional request options
		 * @param {String} [senderId] The unique string identifier of the the query sender
		 * @returns {Promise<Object>} Returns a promise resolved with a JSON object from server
		 */
		runQuery() {}
	}

	return QueryRunnerAPI;
});
